import type {
  GetRewardOffersResponse,
  GetRewardOffersParams,
} from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const rewardsApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getRewards: build.query<GetRewardOffersResponse, GetRewardOffersParams['retailUnit']>({
      query: (retailUnitId: string) => `/${retailUnitId}/rewards`,
    }),
  }),
});

export const { useGetRewardsQuery } = rewardsApis;
